module.exports = __webpack_public_path__ + "static/img/page32.857fe62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page32.jpg
// module id = 21Ch
// module chunks = 0